
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/collectibles/[projectId]/shop",
      function () {
        return require("private-next-pages/[locale]/collectibles/[projectId]/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/collectibles/[projectId]/shop"])
      });
    }
  